import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[LeaveSiteReason SetFilter] Action',
  ResetFilter: '[LeaveSiteReason ResetFilter] Action',
}

const initialLeaveSiteReasonState: ILeaveSiteReasonState = {
  filter: {
    status: '',
    active: true,
  },
}

export interface ILeaveSiteReasonState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-LeaveSiteReason', whitelist: ['filter']},
  (
    state: ILeaveSiteReasonState = initialLeaveSiteReasonState,
    action: ActionWithPayload<ILeaveSiteReasonState>
  ) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialLeaveSiteReasonState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
